export default {
  getPlots: state => {
    return state.plots;
  },
  getPageable: state => {
    return state.pageable;
  },
  getFeaturesForPoint: state => {
    return state.features.toJS().filter(f => f.geometry.type === "Point");
  },
  getFeaturesForPolygon: state => {
    return state.features.toJS().filter(f => f.geometry.type === "Polygon");
  },
}
